import React from 'react';
import { Snackbar, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackbar } from '../redux';

export default () => {
  const dispatch = useDispatch();
  const snackbar = useSelector(state => state.tasks.snackbar);

  return (
    <Snackbar
      style={{ zIndex: '1400' }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={() => dispatch(setSnackbar({ open: false, message: null }))}
      message={snackbar.message}
      action={
        <>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => dispatch(setSnackbar({ open: false, message: null }))}
          >
            <Close fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
};
